import { useParams } from "react-router-dom";
import { ETableEditAction } from "../../../Utils/Enums";
import { InstructorPaymentsProps } from "../../../Utils/Types";
import { endpoints } from "../../../Utils/UrlEnum";
import MUIDataTableCustomStyle from "../../MUIDataTableCustomStyle";
import { Vocabulary } from "../../../Utils/Vocabulary";
import { formatDate } from "../../../Utils/Utils";

export default function InstructorPayments(props: InstructorPaymentsProps) {
  const { triggerReload, instructorId } = props;
  const { id } = useParams();
  const endpointUrl = `${endpoints.payments.forInstructor}/${id}/${instructorId}`;

  const columns = [
    {
      name: "incrementId",
      label: Vocabulary.id,
      options: {
        sort: false,
      },
    },
    {
      name: "accountId",
      label: Vocabulary.account,
      options: {
        sort: false,
        customBodyRender: (account: any) => {
          return account?.name;
        },
      },
    },
    {
      name: "amount",
      label: Vocabulary.amount,
      options: {
        sort: false,
      },
    },
    {
      name: "userId",
      label: Vocabulary.instructor,
      options: {
        sort: false,
        customBodyRender: (account: any) => {
          return account?.firstName + " " + account?.lastName;
        },
      },
    },
    {
      name: "paymentMethod",
      label: Vocabulary.paymentMethod,
      options: {
        sort: false,
      },
    },
    {
      name: "createdAt",
      label: Vocabulary.createdAt,
      options: {
        sort: false,
        customBodyRender: (date: Date) => {
          return formatDate(date);
        },
      },
    },
  ];
  return (
    <div style={{ marginTop: 20 }}>
      <MUIDataTableCustomStyle
        CRUDEndPoint={endpointUrl}
        title={""}
        columns={columns}
        onEditAction={ETableEditAction.NONE}
        hideAddButton
        hideDeleteButton
        hideEditButton
        hideSearch
        triggerReload={triggerReload}
      />
    </div>
  );
}
